import {
  DEVICE,
  DEVICES,
  type Device,
} from '@backmarket/http-api/src/api-specs-content/models/device'
import type { Maybe } from '@backmarket/utils/types/Maybe'

export const isHiddenOnAllDevices = ({
  devices = [],
}: {
  devices: Maybe<Device[]>
}) => {
  if (!devices) return false

  return (
    devices.length === DEVICES.length &&
    devices.every((device) => DEVICES.includes(device)) &&
    DEVICES.every((device) => devices.includes(device))
  )
}

export function getClassesByHiddenDeviceType({
  hiddenDevices,
  classes,
}: {
  hiddenDevices: Device[]
  classes: VisibilityOnDeviceClasses
}) {
  const isHiddenOnExactlyOneDeviceType = hiddenDevices.length === 1

  // the only use case for visibility classes
  // is when the element is hidden on exactly one device type
  if (!isHiddenOnExactlyOneDeviceType) return ''

  const hiddenOn = hiddenDevices[0]

  return classes[hiddenOn]
}

export const HIDE_ON_DEVICE_CLASSES = {
  [DEVICE.Mobile]: 'hidden md:block',
  [DEVICE.Desktop]: 'block md:hidden',
} as const

export const SHOW_ON_DEVICE_CLASSES = {
  [DEVICE.Mobile]: 'block md:hidden',
  [DEVICE.Desktop]: 'hidden md:block',
} as const

export type VisibilityOnDeviceClasses =
  | typeof HIDE_ON_DEVICE_CLASSES
  | typeof SHOW_ON_DEVICE_CLASSES

export function getCTAClassesByHiddenDeviceType({
  hiddenDevices,
}: {
  hiddenDevices: Maybe<Device[]>
}) {
  if (!hiddenDevices) return ''

  const hideOnMobile = hiddenDevices.includes(DEVICE.Mobile)
  const hideOnDesktop = hiddenDevices.includes(DEVICE.Desktop)

  if (hideOnMobile && hideOnDesktop) return '!hidden'
  if (hideOnDesktop) return HIDE_ON_DEVICE_CLASSES.desktop
  if (hideOnMobile) return HIDE_ON_DEVICE_CLASSES.mobile

  // "ios" & "android" cases
  return ''
}
